import {ModelFilterTechnicalDataGroup} from '@volkswagen-onehub/car-technical-details-bff';
import {TranslateFunction} from '../../utils/translate';
import {I18nKey} from '@volkswagen-onehub/car-technical-details-schemas';
import {getRowDebugText} from './getRowDebugText';
export interface RowDescription {
  disclaimerKey?: I18nKey;
  label: string;
  debugText: string;
}
export function getDescriptions(
  group: ModelFilterTechnicalDataGroup,
  translate: TranslateFunction
): {key: string; description: RowDescription}[] {
  const descriptionMap = group.variations.reduce((acc, variation) => {
    variation.values.forEach((v) => {
      const debugText = getRowDebugText(v.key);
      if (v.description) {
        acc.set(v.key, {
          label: v.description,
          disclaimerKey: v.disclaimerKey,
          debugText,
        });
      }
      if (v.i18nKey) {
        const description = translate(v.i18nKey);
        acc.set(v.key, {
          label: description,
          disclaimerKey: v.disclaimerKey,
          debugText,
        });
      }
    });
    return acc;
  }, new Map<string, RowDescription>());

  return Array.from(descriptionMap.entries()).map(([key, description]) => ({
    key,
    description,
  }));

  //return Array.from(descriptionSet);
}
